import store from '@/store'
import { selectForegroundColor, getDarkThemeColor } from '@/utils/color'
import { isDarkTheme } from '@/composables/useAppTheme'

export default class cardTypesApi {
  static getBackgroundColour (cardType) {
    if (cardType && cardType.color && this.cardTypeExists(cardType)) {
      const rgb = 'rgb(' + cardType.color.red + ',' + cardType.color.green + ',' + cardType.color.blue + ')'
      return isDarkTheme() ? getDarkThemeColor(rgb) : rgb
    } else {
      return isDarkTheme() ? '#2E343C' : '#eeeeee'
    }
  }

  static getTextColour (cardType) {
    if (cardType && cardType.color && this.cardTypeExists(cardType)) {
      return selectForegroundColor(cardType.color.red, cardType.color.green, cardType.color.blue)
    } else {
      return isDarkTheme() ? '#E8EAF0' : '#000000'
    }
  }

  static async cardTypeExists (cardType) { // requires async, don't know why
    if (!cardType) {
      return false
    }
    const cardTypes = store.state.cardTypes.cardTypes
    return cardTypes.includes(cardType.id)
  }

  static async updateCardType (workflowId, cardType, payload) {
    const {
      id,
      title,
      color: { red, green, blue },
      description,
      showInBacklog,
      domainModelRole,
      defaultType,
      generateWithAI,
      order
    } = cardType

    const input = {
      title,
      color: { red, green, blue },
      description,
      showInBacklog,
      domainModelRole,
      defaultType,
      generateWithAI,
      order,
      ...payload
    }
    await store.dispatch('cardTypes/updateCardType', { workflowId, id, input })
  }
}
